module.exports = __webpack_public_path__ + "static/media/waiting.56f41059.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/waiting.mp3
// module id = 462
// module chunks = 9